import { BREAKPOINTS } from "../ApplicationConfig";
import ApplicationState from "../ApplicationState";
import Submitter from "../form/Submitter";
import Validator from "../form/Validator";
import modalLoader from "./ModalLoader";

export default function initDefaultModalFormLoader(selector: string)
{
    modalLoader(
        selector,
        modalId => {
            let modal = document.getElementById(modalId) as HTMLFormElement;
            let validationConfig = {
                name: 'cyrillic',
                phone: 'phone',
                text: 'text',
            };

            new Submitter(modal, '/request/commit/', new Validator(validationConfig)).init();
        },
        modalId => ApplicationState.modal.show(modalId, {
            onShow: modal => {
                let body = document.querySelector('body');
                if (document.documentElement.clientWidth >= BREAKPOINTS.LG) {
                   body.setAttribute('style', "overflow:hidden; margin-right: " + (window.innerWidth - document.documentElement.clientWidth) + "px;");
                }
                let autofocusInput = modal.querySelector('input[name="name"]');
                if (autofocusInput) {
                    autofocusInput.focus();
                }
            },
            onClose: modal => {
                let body = document.querySelector('body');
                if (document.documentElement.clientWidth >= BREAKPOINTS.LG) {
                   body.setAttribute('style', 'overflow:initial; margin-right: initial;') ;
                }
            },
            awaitCloseAnimation: true,
            disableFocus: true,
        })
    );
}
